(function () {
  window.__pkVideoClickToPlayBound = true;

  function playVideo(container) {
    if (!container || container.classList.contains('is-playing')) {
      return;
    }

    var iframe = container.querySelector('iframe[data-src]');

    if (!iframe) {
      return;
    }

    var videoSrc = iframe.getAttribute('data-src');

    if (!videoSrc) {
      return;
    }

    iframe.setAttribute('src', videoSrc);
    container.classList.add('is-playing');
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-pk-video-button]');

    if (!button) {
      return;
    }

    event.preventDefault();
    playVideo(button.closest('[data-pk-video-container]'));
  });
})();
